module.exports = __webpack_public_path__ + "img/214.35f02aa1.png";